import posthog from "posthog-js";
import { env } from "~/env.mjs";

export { posthog };

export function isPostHogBrowserEnabled(): boolean {
  return (
    typeof window !== "undefined" &&
    env.NEXT_PUBLIC_VERCEL_ENV === "production" &&
    !env.NEXT_PUBLIC_DEPLOYMENT_URL.includes("localhost") &&
    Boolean(env.NEXT_PUBLIC_POSTHOG_API_KEY) &&
    Boolean(env.NEXT_PUBLIC_POSTHOG_HOST)
  );
}

// Without analytics consent these events are anonymous (memory
// persistence, no person profile, no account linking). Consent only adds
// the persistent identity; identify() is gated in PostHogAppProvider.
export function capturePostHogEvent(
  event: string,
  properties?: Record<string, unknown>,
): void {
  posthog.capture(event, properties);
}
